import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=edffd0c4"
import script from "./cropper.vue?vue&type=script&lang=js"
export * from "./cropper.vue?vue&type=script&lang=js"
import style0 from "./cropper.vue?vue&type=style&index=0&id=edffd0c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports